import React, { useRef, useEffect } from 'react';
import { Form, Input } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

function Honor(props) {
  const formRefs = useRef<any[]>([]);
  const { type, data } = props;
  const { campusResumeDetail, socialResumeDetail, socialResumeFormRefStore, campusResumeFormRefStore } = useRootStore();

  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    store = socialResumeDetail;
    storeRef = socialResumeFormRefStore;
  }

  useEffect(() => {
    storeRef.changeRef('resumeHonorListRef', formRefs.current);
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    store.setResumeHonorList(index, formItemKey, formItemValue);
  };

  return (
    <div className="honor_edit model_edit">
      <div className="model_title">荣誉</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            className="modal_form"
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="honorName" span="11" labelWidth={0} required message="请填写荣誉名称">
              <div className="label">
                荣誉名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入荣誉名称" maxLength={1000} />
            </FormItem>
            <FormItem formItemKey="honorDesc" span="11" labelWidth={0}>
              <div className="label">荣誉描述</div>
              <Input.TextArea
                className="input_text_area"
                toFormItem
                placeholder="请输入荣誉描述"
                showCount
                maxLength={2000}
                autosize={{ minRows: 2, maxRows: 6 }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeHonorList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div className="list_add" onClick={() => store.addResumeList('resumeHonorList')}>
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加荣誉
      </div>
    </div>
  );
}

export default ModuleView(observer(Honor), 'honor');
